import React from 'react';
import { fireEvent, render, screen, waitFor } from '@testing-library/react';

import ConfigProvider from 'components/ConfigProvider';

import AccountsCell from './AccountsCell';
import EMPTY_VALUE from '../../shared/emptyValue';

const renderCell = (props = {}) =>
  render(
    <ConfigProvider>
      <AccountsCell {...props} />
    </ConfigProvider>,
  );

const trigger = () =>
  screen.getByRole('button', { name: /show all accounts/i });

describe('management/Users AccountsCell', () => {
  it('renders a placeholder when the user belongs to no account', () => {
    renderCell({ accounts: [] });

    expect(screen.getByText(EMPTY_VALUE)).toBeInTheDocument();
  });

  it('treats a missing list as empty', () => {
    renderCell();

    expect(screen.getByText(EMPTY_VALUE)).toBeInTheDocument();
  });

  describe('with one account', () => {
    it('shows it inline', () => {
      renderCell({ accounts: ['Account Name A'] });

      expect(screen.getByText('Account Name A')).toBeInTheDocument();
    });

    it('offers no overflow trigger', () => {
      renderCell({ accounts: ['Account Name A'] });

      expect(
        screen.queryByRole('button', { name: /show all accounts/i }),
      ).not.toBeInTheDocument();
    });
  });

  describe('with several accounts', () => {
    const accounts = ['Account Name A', 'Account Name B', 'Account Name C'];

    it('shows only the first inline', () => {
      renderCell({ accounts });

      expect(screen.getByText('Account Name A')).toBeInTheDocument();
      expect(screen.queryByText('Account Name B')).not.toBeInTheDocument();
    });

    // The count is of the hidden ones, not the total.
    it('counts the ones it is hiding', () => {
      renderCell({ accounts });

      expect(
        screen.getByRole('button', { name: 'Show all accounts (2 more)' }),
      ).toBeInTheDocument();
    });

    it('reveals the rest when expanded', async () => {
      renderCell({ accounts });

      fireEvent.click(trigger());

      await waitFor(() =>
        expect(screen.getByText('Account Name B')).toBeInTheDocument(),
      );
      expect(screen.getByText('Account Name C')).toBeInTheDocument();
    });

    it('reports its expanded state', async () => {
      renderCell({ accounts });
      expect(trigger()).toHaveAttribute('aria-expanded', 'false');

      fireEvent.click(trigger());

      await waitFor(() =>
        expect(trigger()).toHaveAttribute('aria-expanded', 'true'),
      );
    });

    it('collapses again on a second click', async () => {
      renderCell({ accounts });

      fireEvent.click(trigger());
      await waitFor(() =>
        expect(screen.getByText('Account Name B')).toBeInTheDocument(),
      );

      fireEvent.click(trigger());

      await waitFor(() =>
        expect(screen.queryByText('Account Name B')).not.toBeInTheDocument(),
      );
    });
  });
});
